import window from 'global/window';
import SocketModel from '../../models/socket';

const protocol = window.location.toString().split(window.location.host)[0];
const websocketProtocol = protocol.replace(/http/, 'ws');
export const legacyWebsocketUrl = `${websocketProtocol}${window.location.host}/websocket`;

export const legacyWebsocket = new SocketModel({url: legacyWebsocketUrl}, {});

export default legacyWebsocket;

import {setGlobal} from '@netx/core-next/utils/setGlobal';
// still needed due to the circular dependency of the netx-model and the websocket model
// which is only extending netx-model to get events - can easily be turned into a mobx store or similar
// and the circular dependency goes away.
// the only reason i am not tackling that now is that we will evenetually have legit websockets and use
// socket.io - so the whole thing changes and this troublesome file is deleted
// if (process.env.NODE_ENV !== 'production') {
setGlobal({websocket: legacyWebsocket});
// }
